export default "__VITE_ASSET__DBbAq6rl__"